export enum PurchaseOrderReferenceType {
  VendorRelease = 'vendor_release',
  Redelivery = 'redelivery',
}
